import digitalData from 'digital-data';

export const smartFilterListenerAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('smart-filter.query-submission', ({output}) => {
    const {question} = output || {};

    digitalData.event.push({
      category: {primaryCategory: 'button submission'},
      eventInfo: {eventName: 'find matching filters'},
      smartFilter: {question: question || '' }
    });
  });
 };
